module.exports = __webpack_public_path__ + "static/media/pathi_l.ffb44178.png";